import * as React from 'react';

import { enumCustomAttributeEntityType } from '@rematter/frontend-lib-api-client';

import { LabeledText } from './LabeledText';
import { SalesOrderTabCustomerSectionInfo } from './SalesOrderTabCustomerSectionInfo';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { SalesOrderRecord } from '~/modules/trade/types/salesOrder';
import { CustomAttributeRecord } from '~/shared/components/custom-attributes/types';
import { useCustomAttributeDefinitionsQuery } from '~/shared/graphql/queries/useCustomAttributeDefinitionsQuery';

type Props = {
  salesOrder: SalesOrderRecord;
};

export const SalesOrderTabCustomerSectionCustomAttributes: React.FC<Props> = ({
  salesOrder,
}) => {
  const t = useTranslations();

  // Use the shared custom attributes query
  const { data: customAttributeDefinitions, isLoading } =
    useCustomAttributeDefinitionsQuery({
      entityType: enumCustomAttributeEntityType.CRMAccount,
    });

  // Get custom attribute values from the sales order
  const customAttributeValues = salesOrder.account?.customAttributes ?? {};

  if (isLoading) {
    return (
      <SalesOrderTabCustomerSectionInfo
        title={t.salesOrderDetail.customer.customAttributes.title}
      >
        <div className="flex flex-col items-center justify-center py-4">
          <div className="animate-pulse">
            <div className="h-4 w-24 rounded bg-neutral/20"></div>
          </div>
        </div>
      </SalesOrderTabCustomerSectionInfo>
    );
  }

  // Only show if we have custom attribute definitions
  if (!customAttributeDefinitions || customAttributeDefinitions.length === 0) {
    return null;
  }

  return (
    <SalesOrderTabCustomerSectionInfo
      className="@SalesOrderTabCustomerSectionCustomAttributes"
      title={t.salesOrderDetail.customer.customAttributes.title}
    >
      <div className="mt-4 grid grid-cols-3 gap-4">
        {customAttributeDefinitions.map((attribute: CustomAttributeRecord) => (
          <div key={attribute.id}>
            <LabeledText
              label={attribute.name}
              text={customAttributeValues[attribute.name] ?? '-'}
            />
          </div>
        ))}
      </div>
    </SalesOrderTabCustomerSectionInfo>
  );
};
